import React, { Component } from 'react';
import cx from 'classnames';

import { pluralize } from 'utils';
import Dropdown from 'components/common/Dropdown';
import Menu from 'components/common/Menu';
import s from '../styles';
import { withTranslation } from 'react-i18next';

class SubFilters extends Component {
  render() {
    const {
      sorts,
      sort,
      sortKeys,
      total,
      handleSortChange,
      t
    } = this.props;
    return (
      <div className={s.FlatsListTitle}>
        <p>{total} {pluralize(total, t('components.flatsList.subFilters.flat1'), t('components.flatsList.subFilters.flat2'), t('components.flatsList.subFilters.flat3'))}</p>
        <div className={s.FlatsListSort}>
          <Dropdown
            className={cx(s.Dropdown)}
            buttonStyle={s.DropdownButton}
            iconStyle={s.DropdownIcon}
            text={t('components.flatsList.subFilters.sort', {
              sort: sorts[sort].text
            })}
            textStyle={s.DropdownText}
            topShift
          >
            <Menu rightArrow pure className={s.DropdownMenu}>
              {sortKeys.map(
                (key) =>
                  <span
                    onClick={() => handleSortChange(key)}
                    className={s.DropdownMenuItem}
                    key={key}
                  >
                    {sorts[key].text}
                  </span>
              )}
            </Menu>
          </Dropdown>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SubFilters);



// WEBPACK FOOTER //
// ./src/components/FlatsList/SubFilters/SubFilters.js